import { cache as canvasCache } from './get-canvas-area';
import { cache as imageCache } from './get-image-by-meta';

const cleanup = () => {
  canvasCache.clear();
  imageCache.clear();
};

export default cleanup;
